module.exports = __webpack_public_path__ + "static/Barclays-logo-new-80ee46d82a9fce24f011db7f4be8297c.svg";